import Favorites from "./favorites"
import View from "./View"
import Metafiles from "./metafiles"
import GeneralHelper from "./generalHelper"
import Thumbnail from "./thumbnail"

export default class Search {
  static Subscribe() {
    $(".search-box").keyup(function(e) {
        var keyCode = e.keyCode || e.which;
        $(".search-box-container label.error").html("");
        if (keyCode == '13'){
            $("+ .search-button", this).trigger("click");
        }
    });

    $('.search-button').click(function() {
        var text = $(this).closest('.search-box-container').find('.search-box').val();
        var me = this ;

        $(".search-box-container label.error").html("");
        window.AppInstance.instance().previous_path = window.AppInstance.instance().path;
        if ( text.length < 3 ) {
            $(".search-box-container label.error").html("Enter a value that is more than 3 characters");
        } else {
            View.wizardLoading(true, false, true);
            var ps = [];
            var s = { Text: ','+ text +',', IncludeData: true, Limit:250, Match : { Archived: false, Owned: false, Shared: true, Class2: null, Tags : [{ Name: window.PatternBuilder.config().SETNAME+'/**', Archived: false, Owned: false, Shared: true }] }} ;
            if ( $(this).closest('.search-box-container').find("input[name='search-type']:checked").val() === "inside-current" )
            {
                if ( window.AppInstance.instance().m_patterns.length > 0 )
                    s.Match.Tags = [{ Name: (window.AppInstance.instance().path!==undefined ? window.AppInstance.instance().path:window.PatternBuilder.config().SETNAME), Archived: false, Owned: false, Shared: true }];
                else
                    s.Match.Tags = [{ Name: (window.AppInstance.instance().path!==undefined ? window.AppInstance.instance().path:window.PatternBuilder.config().SETNAME)+'/**', Archived: false, Owned: false, Shared: true }];
            }
            //search by ",tag,", ",tag", "tag,"
            ps.push(Cx.Core.Document.search$(s));

            Cx.whenAll(ps).then(function(r){
              var items = [];
              Cx_.forEach(r, function(ri) {
                  Cx_.forEach(ri.Items, function(item) {
                      var c = Cx_.filter(items, function(i) {
                          return ( i.Id === item.Id )
                      });
                      if ( c.length === 0 ) //if not already there
                          items.push(item) ;
                  });
              });
              if (items.length > 0 )
              {
                  Metafiles.clear_canvas$().then(function() {
                      window.AppInstance.instance().active_search = true ;
                      window.AppInstance.instance().m_patterns = items ;
                      window.AppInstance.instance().m_patterns = Cx_.sortBy(window.AppInstance.instance().m_patterns, function (pattern) {
                          return GeneralHelper.get_display_order_value(pattern.Cdl);
                      });
                      window.AppInstance.instance().m_patterns = Cx_.filter(window.AppInstance.instance().m_patterns , function(pattern) {
                          return (  ( pattern.Class2 === 'raster' ) || ( pattern.Class2 === 'vector' ) );
                      });
                      window.AppInstance.instance().m_patterns = Cx_.filter(window.AppInstance.instance().m_patterns, function(pattern) {
                          return ( GeneralHelper.has_valid_tags( pattern.Tags, window.PatternBuilder.config().SETNAME ) );
                      });
                      window.AppInstance.instance().m_patterns = Cx_.filter(window.AppInstance.instance().m_patterns, function(pattern) {
                          return ( ( pattern.Cdl.indexOf('Type="designer"') == -1 ) && ( pattern.Cdl.indexOf('Type="category"') == -1 ) );
                      });
                      window.AppInstance.instance().m_patterns = Cx_.filter(window.AppInstance.instance().m_patterns, function(pattern) {
                          return ( pattern.Archived === false );
                      });
                      window.AppInstance.instance().m_patterns = Cx_.filter(window.AppInstance.instance().m_patterns, function(pattern) {
                          return ( pattern.Cdl.indexOf('ParentDocumentID') == -1 );
                      });
                      if ( window.AppInstance.instance().m_patterns.length > 0 )
                      {
                        $('#pattern-squares').html('');

                          View.load_content$('pattern-squares', window.PatternBuilder.config().SETNAME.replace(/[/]$/,""), false).then(function(){

                          Thumbnail.load_main_thumbnails('pattern-squares', window.AppInstance.instance().m_patterns );

                            Favorites.render_event_handler();

                            $("#wizard-container .tab-list li a").removeClass("selected");
                            $("#pattern-steps .tab-content:visible").hide();
                            $("#pattern-steps .choose-pattern").show();
                            $("#wizard-container .tab-list li.choose-pattern a").removeClass("disabled-btn").addClass("selected");
                            $("#BrowserHeading").html('Search Results: ' + text  + ' <a class="clear-search" onclick="window.resetPatternBuilder();">[X]</a>');
                            $(".browser-container").html('<span onclick="window.collection_home();"><span style="cursor:pointer;">Collection Home</span></span> > <span><span>Search Results</span></span>');
                            //$(".pattern-name").dotdotdot({ ellipsis: "...",  wrap: "letter"});
                        });
                      }
                      else{
                          View.wizardLoading(true, false, false);
                          $(".search-box-container label.error").html("No results found");
                      }
                  });
              }
              else{
                  View.wizardLoading(true, false, false);
                  $(".search-box-container label.error").html("No results found");
              }
          })
          .catch(function(e) {
            GeneralHelper.errorOut(e);
          });
        }
    });
  }
}
